import {useCallback, useState} from 'react';

import {useApi} from '~/modules/api';
import {PollList, PollStats} from '~/types';

export const useGetPollInfo = ({
  mode,
  pollId,
}: {
  mode: 'pollList' | 'pollStats';
  pollId?: string;
}) => {
  const [downloadingPollInfoStatus, setDownloadingPollInfoStatus] = useState<
    'none' | 'requesting' | 'success' | 'error'
  >('none');
  const [downloadingPollInfoErrorMsg, setDownloadingPollInfoErrorMsg] =
    useState('');

  const [pollList, setPollList] = useState<PollList>();
  const [pollStats, setPollStats] = useState<PollStats>();

  const api = useApi();
  const getPollInfo = useCallback(async () => {
    try {
      if (
        downloadingPollInfoStatus === 'none' ||
        (downloadingPollInfoStatus === 'error' &&
          downloadingPollInfoErrorMsg !==
            'You need permission to access this resource')
      ) {
        setDownloadingPollInfoStatus('requesting');
        setDownloadingPollInfoErrorMsg('');
        const {data} = await api.fetch({
          url: '/pollStats',
          method: 'POST',
          data: {mode, pollId},
        });
        if (data.status !== 'success') {
          throw new Error(data.errorMessage);
        }
        if (mode === 'pollList') {
          setPollList(data.data);
        }
        if (mode === 'pollStats') {
          setPollStats(data.data);
        }

        setDownloadingPollInfoStatus('success');
        return data;
      }
    } catch (error) {
      setDownloadingPollInfoStatus('error');
      if (error instanceof Error) {
        setDownloadingPollInfoErrorMsg(error.message);
      }
    }
  }, [
    api,
    downloadingPollInfoErrorMsg,
    downloadingPollInfoStatus,
    mode,
    pollId,
  ]);

  return {
    downloadingPollInfoErrorMsg,
    downloadingPollInfoStatus,
    getPollInfo,
    pollList,
    pollStats,
  };
};
